export enum AnalyticsActionTypes {
  SET_FILTER = 'ANALYTICS_SET_FILTER',
  START_FILTERS = 'ANALYTICS_START_FILTERS',
  FINISH_FILTERS = 'ANALYTICS_FINISH_FILTERS',
  START_SEARCH = 'ANALYTICS_START_SEARCH',
  FINISH_SEARCH = 'ANALYTICS_FINISH_SEARCH',
  START_AGGREGATE = 'ANALYTICS_START_AGGREGATE',
  FINISH_AGGREGATE = 'ANALYTICS_FINISH_AGGREGATE',
  API_ERROR = 'ANALYTICS_API_ERROR',
}

export type CheckTypeName = 'tug' | 'cs30' | 'ss5' | 'balance';

export const CHECK_TYPE_LABEL: Record<CheckTypeName, string> = {
  tug: 'TUG',
  cs30: 'CS-30',
  ss5: 'SS-5',
  balance: '開眼片足立ち',
};

export const CHECK_TYPE_UNIT: Record<CheckTypeName, string> = {
  tug: '秒',
  cs30: '回',
  ss5: '秒',
  balance: '秒',
};

export const DEFAULT_BINS: Record<CheckTypeName, number[]> = {
  tug: [8, 12, 20],
  cs30: [10, 15, 20],
  ss5: [8, 12, 20],
  balance: [10, 30, 60],
};

export interface AnalyticsFilters {
  company_names: string[];
  institutions: { institution_sub: string; institution_name: string; company_name: string }[];
  care_levels: string[];
  genders: string[];
  check_types: string[];
}

export interface MeasurementFilter {
  check_type: CheckTypeName;
  company_names?: string[];
  institution_subs?: string[];
  genders?: string[];
  care_levels?: string[];
  measurement_types?: string[];
  started_from?: string;
  started_to?: string;
  value_range?: { min?: number; max?: number };
  age_bands?: [number, number][];
}

export interface MeasurementFact {
  check_type: string;
  started_at: string;
  primary_value: number | null;
  direction: string;
  measurement_type: string | null;
  user_name: string | null;
  user_gender: string | null;
  user_care_level: string | null;
  age_at_measurement: number | null;
  institution_name: string | null;
  company_name: string | null;
  join_status: string;
  is_outlier: boolean;
}

export interface AggregateRow {
  bin: string;
  persons: number;
  measurements: number;
  [axis: string]: string | number;
}

export interface AnalyticsState {
  filters: AnalyticsFilters | null;
  filterLoaded: boolean;
  currentFilter: MeasurementFilter | null;
  list: { items: MeasurementFact[]; count: number; page: number; perPage: number; loading: boolean };
  aggregate: { rows: AggregateRow[]; bins: number[]; groupBy: string[]; dedupe: 'latest' | 'all'; loading: boolean };
  error: Error | null;
}
